import designToolTemplate from './templates/design-tool.twig';

/**
 * @class {DesignTool}
 */
class DesignTool {
  /**
   * @param {HTMLElement} container
   * @param {object} translations
   */
  constructor(container, translations) {
    this._available = ['background', 'borders', 'padding', 'radius'];
    this._dom = {
      'background': {
        'explorerBtn': '.explorer-btn',
        'sizeWrapper': '.bg-size-wrapper',
      },
      'borders': {
        'locked': '.borders-locked',
        'toggle': '.borders-toggle',
        'unlocked': '.borders-unlocked',
        'wrapper': '.borders-wrapper',
        'switch': '.borders-switch',
        'label': '.borders-switch-label',
      },
      'padding': {
        'toggle': '.padding-locked',
        'label': '.padding-locked-label',
      },
      'radius': {
        'toggle': '.radius-locked',
        'label': '.radius-locked-label',
      },
    };
    this._inputs = {};

    this._translations = translations;
    this._elem = container;

    $(this._elem).html(designToolTemplate({
      i18n: {
        line: (key) => {
          if (!(key in this._translations)) {
            throw new Error('DesignTool: No translation found for key "' + key + '"');
          }

          return this._translations[key];
        },
      },
    }));

    this._preview = this._elem.querySelector('.design-tool-preview');
    this._selection = this._elem.querySelector('.design-tool-selection');

    // Define available properties
    this._available.forEach((type, i) => {
      const area = this._elem.querySelector(`.design-tool-${type}`);

      if (area !== null) {
        area.querySelectorAll('[data-property]').forEach((input) => {
          const property = input.getAttribute('data-property');
          this._inputs[property] = null;
        });
      }
    });

    if (this._selection.value !== '') {
      // Get selection
      this._getSelection();

      // Set values
      this._setValues();
    } else {
      // Get values
      this._getValues();
    }

    this._setForm();
    this._toggleSelected();
    this._setPreview();

    // Init
    this._init();
  };

  /**
   * Get form values string
   * @return {string}
   */
  getValue() {
    // No background image, no related CSS
    if (this._selection.value.indexOf('background-image:url()') !== -1) {
      const ignoredRules = ['background-image:url()', 'background-position', 'background-repeat'];

      return this._selection.value.trim().split(';').filter((value) => {
        let find = false;
        ignoredRules.forEach((ignoredRule) => {
          if (value.trim().indexOf(ignoredRule) !== -1) {
            find = true;
          }
        });
        return !find;
      }).join(';');
    } else {
      return this._selection.value.trim();
    }
  }

  /**
   * Set form values string
   * @param {string} value
   */
  setValue(value) {
    this._selection.value = value;

    this._getSelection();
    this._setValues();
    this._setPadding();
    this._setRadius();
    this._setBackgroundUrl();
    this._setPreview();

    // handle image preview in "explorer-btn"

    if (this._inputs['background-image'] !== null && this._inputs['background-image'] !== '') {
      const $explorerBtn = $(this._elem.querySelector(this._dom.background.explorerBtn));
      $explorerBtn.find('img').attr('src', this._inputs['background-image']);
      $explorerBtn.find('.img-expanded').toggleClass('d-none', $explorerBtn.find('img[src=""]').length);
    }
  }

  // @todo handle form DOM reset
  // /**
  //  * Reset form
  //  */
  // reset() {
  //   this._selection.value = '';
  //
  //   this._setPadding();
  //   this._setRadius();
  //   this._setBackgroundUrl();
  //   this._setPreview();
  // }

  /**
   * @private
   */
  _init() {
    // Disable borders
    this._elem.querySelector(this._dom.borders.toggle).addEventListener('click', (e) => {
      this._elem.querySelector(this._dom.borders.wrapper).classList.toggle('hide');
      this._bordersLocked(true);
      this._setBorders();
      this._setPreview();
    });

    // // Toggle locked radius from label
    this._elem.querySelector(this._dom.borders.label).addEventListener('click', (e) => {
      this._elem.querySelector(this._dom.borders.switch).click();
    });

    // Switch borders
    this._elem.querySelector(this._dom.borders.switch).addEventListener('click', (e) => {
      if (this._elem.querySelector(this._dom.borders.switch).checked) {
        this._elem.querySelector(this._dom.borders.unlocked).click();
      } else {
        this._elem.querySelector(this._dom.borders.locked).click();
      }
    });

    // Lock borders
    this._elem.querySelector(this._dom.borders.locked).addEventListener('click', (e) => {
      this._bordersLocked(true);
      this._setBorders();
      this._setPreview();
    });

    // Unlock borders
    this._elem.querySelector(this._dom.borders.unlocked).addEventListener('click', (e) => {
      this._bordersLocked(false);
      this._setBorders();
      this._setPreview();
    });

    // // Toggle locked padding from label
    this._elem.querySelector(this._dom.padding.label).addEventListener('click', (e) => {
      this._elem.querySelector(this._dom.padding.toggle).click();
    });

    // Toggle locked padding
    this._elem.querySelector(this._dom.padding.toggle).addEventListener('click', (e) => {
      const button = this._elem.querySelector(this._dom.padding.toggle);

      console.log(button);

      const paddingRight = this._elem.querySelector('[data-property="padding-right"]');
      const paddingBottom = this._elem.querySelector('[data-property="padding-bottom"]');
      const paddingLeft = this._elem.querySelector('[data-property="padding-left"]');

      if (button.checked === false) {
        paddingRight.closest('.row').classList.add('d-none');
        paddingBottom.closest('.row').classList.add('d-none');
        paddingLeft.closest('.row').classList.add('d-none');

        // switch logo
        this._elem.querySelector('.margin-top-icon').classList.add('d-none');
        this._elem.querySelector('.margin-uniform-icon').classList.remove('d-none');
      } else {
        button.setAttribute('checked', 'checked');

        paddingRight.closest('.row').classList.remove('d-none');
        paddingBottom.closest('.row').classList.remove('d-none');
        paddingLeft.closest('.row').classList.remove('d-none');

        // switch logo
        this._elem.querySelector('.margin-top-icon').classList.remove('d-none');
        this._elem.querySelector('.margin-uniform-icon').classList.add('d-none');
      }

      this._setPadding();
      this._setPreview();
    });

    // // Toggle locked radius from label
    this._elem.querySelector(this._dom.radius.label).addEventListener('click', (e) => {
      this._elem.querySelector(this._dom.radius.toggle).click();
    });

    // Toggle locked radius
    this._elem.querySelector(this._dom.radius.toggle).addEventListener('click', (e) => {
      const button = this._elem.querySelector(this._dom.radius.toggle);
      const topRightRadius = this._elem.querySelector('[data-property="border-top-right-radius"]');
      const bottomRightRadius = this._elem.querySelector('[data-property="border-bottom-right-radius"]');
      const bottomLeftRadius = this._elem.querySelector('[data-property="border-bottom-left-radius"]');

      if (button.checked === false) {
        topRightRadius.closest('.col-lg-6').classList.add('d-none');
        bottomRightRadius.closest('.col-lg-6').classList.add('d-none');
        bottomLeftRadius.closest('.col-lg-6').classList.add('d-none');

        // switch logo
        this._elem.querySelector('.border-radius-top-icon').classList.add('d-none');
        this._elem.querySelector('.border-radius-uniform-icon').classList.remove('d-none');
      } else {
        button.setAttribute('checked', 'checked');

        topRightRadius.closest('.col-lg-6').classList.remove('d-none');
        bottomRightRadius.closest('.col-lg-6').classList.remove('d-none');
        bottomLeftRadius.closest('.col-lg-6').classList.remove('d-none');

        // switch logo
        this._elem.querySelector('.border-radius-top-icon').classList.remove('d-none');
        this._elem.querySelector('.border-radius-uniform-icon').classList.add('d-none');
      }

      this._setRadius();
      this._setPreview();
    });

    // Init colorpickers
    forms.color.init($(this._elem).find('.is_color_preview'));

    // Explorer btn callbacks
    const _this = this;
    const $explorerBtn = $(this._elem.querySelector(this._dom.background.explorerBtn));

    window.forms.explorerBtn.init($explorerBtn);

    $explorerBtn.on({
      'onSelect': () => {
        _this._setBackgroundUrl();
        _this._setPreview();
      },
      'onRemove': function() {
        _this._setBackgroundUrl();
        _this._setPreview();
      },
    });

    // On radios change
    const radios = [];
    Object.keys(this._inputs).filter((property) => {
      return this._elem.querySelector(`[data-property="${property}"]`).getAttribute('type') === 'radio';
    }).forEach((property) => {
      if (radios.indexOf(property) === -1) {
        radios.push(property);
      }
    });
    radios.forEach((property) => {
      const inputs = this._elem.querySelectorAll(`[data-property="${property}"]`);

      inputs.forEach((input) => {
        input.addEventListener('change', (e) => {
          this._toggleSelected();

          this._inputs[property] = input.getAttribute('value');
          this._setPreview();
        });
      });
    });

    // On inputs change
    Object.keys(this._inputs).filter((property) => {
      return this._elem.querySelector(`[data-property="${property}"]`).getAttribute('type') !== 'radio';
    }).forEach((property) => {
      const input = this._elem.querySelector(`[data-property="${property}"]`);
      const isColor = property.indexOf('color') !== -1;

      // is color
      if (isColor) {
        $(input).on('change.spectrum', (e, color) => {
          this._inputs[property] = e.target.value;
          this._setPreview();
        });
      }

      // Listen input's change
      input.addEventListener('change', (e) => {
        this._inputs[property] = e.target.value;

        // Is size property ?
        if (property === 'background-size') {
          this._setBackgroundSize();
        }

        // Is padding ?
        if (property.includes('padding')) {
          this._setPadding();
        }

        // Is radius ?
        if (property.includes('radius')) {
          this._setRadius();
        }
        this._setPreview();
      });
    });
  };

  /**
   * @param {boolean} locked
   * @private
   */
  _bordersLocked(locked) {
    this._elem.querySelector('.border-wrapper').classList.toggle('hide', locked === false);

    const sides = ['top', 'right', 'bottom', 'left'];
    sides.forEach((side) => {
      this._elem.querySelector(`.border-${side}-wrapper`).classList.toggle('hide', locked === true);
    });
  };

  /**
   * Fill this._inputs with selection data
   * @private
   */
  _getSelection() {
    for (const key in this._inputs) {
      this._inputs[key] = null;
    }

    const styles = this._selection.value.trim().split(';');

    styles.filter((style) => {
      return style.trim() !== '';
    }).forEach((style) => {
      const split = style.split(':');

      // Wrong CSS rule
      if (split.length < 2) {
        throw new Error(
          'DesignTool: Trying to define wrong CSS rule in selection' +
          ' ("' + style + '" in "' + this._selection.value + '")',
        );
      }

      const property = split[0].trim();
      const borderSides = property.match(/^border-(top|right|bottom|left)$/);

      if (!(property in this._inputs) &&
        !borderSides && (property !== 'padding') && (property !== 'border') && (property !== 'border-radius')) {
        throw new Error(
          'DesignTool: Trying to define unknown CSS rule in selection' +
          ' ("' + property + '" in "' + this._selection.value + '")',
        );
      }

      const value = split.slice(1).join(':').trim();

      if (property === 'background-size') {
        this._inputs['background-size'] = value;

        if (['cover', 'contain'].indexOf(value) === -1) {
          const unit = value.indexOf('%') !== -1 ? '%' : 'px';
          const w = value.split(' ')[0].replace(unit, '');
          const h = value.split(' ')[1].replace(unit, '');

          this._inputs['background-size'] = unit;
          this._inputs['background-width'] = w !== 'auto' ? w : this._inputs['background-width'];
          this._inputs['background-height'] = h !== 'auto' ? h : this._inputs['background-height'];
          this._inputs['background-width-unit'] = unit;
          this._inputs['background-height-unit'] = unit;
        }
      } else if (property === 'border') {
        this._inputs['border-style'] = value.split(' ')[1];
        this._inputs['border-width'] = value.split(' ')[0].replace('px', '');
        // fix on "rgb(num, num, num)", not rgb(num,num,num)
        this._inputs['border-color'] = value
          .split(' ')
          .filter((e, index) => {
            return (index > 1);
          }).join(' ');
      } else if (property === 'background-image') {
        this._inputs['background-image'] = value.match(/url\((.*?)\)/)[1];
      } else if (borderSides !== null) {
        const side = borderSides[1];
        this._inputs[`border-${side}-style`] = value.split(' ')[1].trim() !== '' ? value.split(' ')[1].trim() : null;
        this._inputs[`border-${side}-width`] = value.split(' ')[0].replace('px', '').trim !== '' ?
          value.split(' ')[0].replace('px', '').trim() :
          null;
        // fix on "rgb(num, num, num)", not rgb(num,num,num)
        this._inputs[`border-${side}-color`] = value
          .split(' ')
          .filter((e, index) => {
            return (index > 1);
          }).join(' ');

        if (this._inputs[`border-${side}-color`].trim() === '') {
          this._inputs[`border-${side}-color`] = null;
        }
      } else if (property === 'padding') {
        const values = value.split(' ');
        const top = values[0];
        const right = values.length === 1 ? values[0] : values[1];
        const bottom = values.length === 1 ? values[0] : values[2];
        const left = values.length === 1 ? values[0] : values[3];
        const paddingSides = {
          'top': top.replace('px', ''),
          'right': right.replace('px', ''),
          'bottom': bottom.replace('px', ''),
          'left': left.replace('px', ''),
        };

        Object.keys(paddingSides).forEach((side) => {
          this._inputs[`padding-${side}`] = paddingSides[side];
        });
      } else if (property === 'border-radius') {
        const values = value.split(' ');
        const topLeft = values[0];
        const topRight = values.length === 1 ? values[0] : values[1];
        const bottomRight = values.length === 1 ? values[0] : values[2];
        const bottomLeft = values.length === 1 ? values[0] : values[3];
        const radiusSides = {
          'top-left': topLeft.replace('px', ''),
          'top-right': topRight.replace('px', ''),
          'bottom-right': bottomRight.replace('px', ''),
          'bottom-left': bottomLeft.replace('px', ''),
        };

        Object.keys(radiusSides).forEach((side) => {
          this._inputs[`border-${side}-radius`] = radiusSides[side];
        });
      } else if (property !== '') {
        this._inputs[property] = value;
      }
    });
  };

  /**
   * @private
   */
  _getValues() {
    Object.keys(this._inputs).forEach((property) => {
      const target = this._elem.querySelector(`[data-property="${property}"]`);
      const isRadio = target.hasAttribute('type') && (target.getAttribute('type') === 'radio');
      let value = target.value;

      if (isRadio) {
        this._elem.querySelectorAll(`[data-property="${property}"]`).forEach((radio) => {
          if (radio.checked === true) {
            value = radio.getAttribute('value');
          }
        });
      }
      this._inputs[property] = value;
    });
  };

  /**
   * @private
   */
  _setBackgroundSize() {
    const wrapper = this._elem.querySelector('.design-tool-background');
    const sizeWrapper = wrapper.querySelector(this._dom.background.sizeWrapper);
    const sizeW = sizeWrapper.querySelector('[data-property="background-width"]');
    const sizeH = sizeWrapper.querySelector('[data-property="background-height"]');
    const units = sizeWrapper.querySelectorAll('.background-unit');
    const value = wrapper.querySelector('[data-property="background-size"]').value;

    this._inputs['background-size'] = value;

    if (['px', '%'].indexOf(value) === -1) {
      sizeWrapper.classList.add('hide');
      sizeW.value = '';
      sizeH.value = '';

      this._inputs['background-width'] = null;
      this._inputs['background-height'] = null;
      this._inputs['background-width-unit'] = null;
      this._inputs['background-height-unit'] = null;
    } else {
      sizeWrapper.classList.remove('hide');
      units.forEach((addon) => {
        addon.innerHTML = value;
      });

      this._inputs['background-width'] = sizeW.value;
      this._inputs['background-height'] = sizeH.value;
      this._inputs['background-width-unit'] = value;
      this._inputs['background-height-unit'] = value;
    }
  };

  /**
   * @private
   */
  _setBackgroundUrl() {
    const url = this._elem.querySelector('[data-property=background-image]').value;

    this._inputs['background-image'] = url;

    if (this._inputs['background-position'] === null) {
      this._inputs['background-position'] = 'left top';
    }

    if (this._inputs['background-repeat'] === null) {
      this._inputs['background-repeat'] = 'repeat';
    }

    if (this._inputs['background-size'] === null) {
      this._inputs['background-size'] = '';
    }

    this._elem.querySelector('[data-property=background-size]').value = this._inputs['background-size'];
    this._elem.querySelectorAll(`[data-property="background-position"]`).forEach((radio) => {
      radio.checked = radio.getAttribute('value') === this._inputs['background-position'];
    });

    this._elem.querySelectorAll(`[data-property="background-repeat"]`).forEach((radio) => {
      radio.checked = radio.getAttribute('value') === this._inputs['background-repeat'];
    });

    this._setBackgroundSize();
    this._toggleSelected();
  };

  /**
   * @private
   */
  _setBorders() {
    const remove = this._elem.querySelector(this._dom.borders.toggle).checked === false;
    const locked = this._elem.querySelector('.border-wrapper').classList.contains('hide') === false;

    ['top', 'right', 'bottom', 'left'].forEach((side) => {
      this._elem.querySelectorAll(`[data-property="border-${side}-style"]`).forEach((radio) => {
        radio.checked = locked ? false : (this._inputs['border-style'] === radio.getAttribute('value'));
      });

      this
        ._elem
        .querySelector(`[data-property="border-${side}-width"]`)
        .value = locked ? '' : this._inputs['border-width'];

      this
        ._elem
        .querySelector(`[data-property="border-${side}-color"]`)
        .value = locked ? '' : this._inputs['border-color'];

      $(this._elem.querySelector(`[data-property="border-${side}-color"]`))
        .spectrum('set', this._elem.querySelector(`[data-property="border-${side}-color"]`).value);

      this._inputs[`border-${side}-style`] = locked ? null : this._inputs['border-style'];
      this._inputs[`border-${side}-width`] = locked ? null : this._inputs['border-width'];
      this._inputs[`border-${side}-color`] = locked ? null : this._inputs['border-color'];
    });

    if (remove || (locked === false)) {
      this._elem.querySelectorAll(`[data-property="border-style"]`).forEach((radio) => {
        radio.checked = false;
      });
      this._elem.querySelector(`[data-property="border-width"]`).value = '';
      this._elem.querySelector(`[data-property="border-color"]`).value = '';
      $(this._elem.querySelector(`[data-property="border-color"]`)).spectrum('set', '');

      this._inputs['border-style'] = null;
      this._inputs['border-width'] = null;
      this._inputs['border-color'] = null;
    }

    this._toggleSelected();
  };

  /**
   * @private
   */
  _setForm() {
    const borders = [];
    const padding = [];
    const radius = [];

    Object.keys(this._inputs).filter((property) => {
      return typeof this._inputs[property] !== 'object';
    }).forEach((property) => {
      const value = this._inputs[property];

      if ((property.match(/^border-(width|color|style)$/) !== null) ||
        (property.match(/^border-(top|right|bottom|left)-(width|color|style)$/) !== null)) {
        borders.push(property);
      } else if ((property.match(/^padding-(top|right|bottom|left)$/) !== null) &&
        (property.match(/^padding-(top|right|bottom|left)$/) !== '') &&
        (value !== '')
      ) {
        padding.push(value);
      } else if ((property.match(/^border-(top-left|top-right|bottom-right|bottom-left)-radius$/) !== null) &&
        (radius.indexOf(value) === -1)) {
        radius.push(value);
      }
    });

    const hasBorders = borders.length > 0; // ???

    this._elem.querySelector(this._dom.borders.toggle).checked = hasBorders;
    this._elem.querySelector(this._dom.borders.wrapper).classList.toggle('hide', hasBorders === false);

    if (hasBorders) {
      let locked = true;

      const sides = ['top', 'right', 'bottom', 'left'];
      sides.forEach((side) => {
        locked = (locked === true) &&
          (this._inputs[`border-${side}-width`] !== null && this._inputs[`border-${side}-width`] !== '') ?
          false :
          locked;
      });

      this._bordersLocked(locked);
    }

    const paddingLocked = padding.length > 0 ? null : 'checked';
    const paddingRight = this._elem.querySelector('[data-property="padding-right"]');
    const paddingBottom = this._elem.querySelector('[data-property="padding-bottom"]');
    const paddingLeft = this._elem.querySelector('[data-property="padding-left"]');

    if (paddingLocked) {
      paddingRight.closest('.row').classList.add('d-none');
      paddingBottom.closest('.row').classList.add('d-none');
      paddingLeft.closest('.row').classList.add('d-none');

      // switch logo
      this._elem.querySelector('.margin-top-icon').classList.add('d-none');
      this._elem.querySelector('.margin-uniform-icon').classList.remove('d-none');
    } else {
      this._elem.querySelector(this._dom.padding.toggle).setAttribute('checked', 'checked');

      paddingRight.closest('.row').classList.remove('d-none');
      paddingBottom.closest('.row').classList.remove('d-none');
      paddingLeft.closest('.row').classList.remove('d-none');

      // switch logo
      this._elem.querySelector('.margin-top-icon').classList.remove('d-none');
      this._elem.querySelector('.margin-uniform-icon').classList.add('d-none');
    }

    let radiusLocked = true;

    ['top-left', 'top-right', 'bottom-right', 'bottom-left'].forEach((side) => {
      radiusLocked = (radiusLocked === true) &&
      (this._inputs[`border-${side}-radius`] !== null && this._inputs[`border-${side}-radius`] !== '') ?
        false :
        radiusLocked;
    });

    // radiusLocked = radius.length > 0 ? 'false' : 'true';
    const topRightRadius = this._elem.querySelector('[data-property="border-top-right-radius"]');
    const bottomRightRadius = this._elem.querySelector('[data-property="border-bottom-right-radius"]');
    const bottomLeftRadius = this._elem.querySelector('[data-property="border-bottom-left-radius"]');

    if (radiusLocked) {
      topRightRadius.closest('.col-lg-6').classList.add('d-none');
      bottomRightRadius.closest('.col-lg-6').classList.add('d-none');
      bottomLeftRadius.closest('.col-lg-6').classList.add('d-none');

      // switch logo
      this._elem.querySelector('.border-radius-top-icon').classList.add('d-none');
      this._elem.querySelector('.border-radius-uniform-icon').classList.remove('d-none');
    } else {
      this._elem.querySelector(this._dom.radius.toggle).setAttribute('checked', 'checked');

      topRightRadius.closest('.col-lg-6').classList.remove('d-none');
      bottomRightRadius.closest('.col-lg-6').classList.remove('d-none');
      bottomLeftRadius.closest('.col-lg-6').classList.remove('d-none');

      // switch logo
      this._elem.querySelector('.border-radius-top-icon').classList.remove('d-none');
      this._elem.querySelector('.border-radius-uniform-icon').classList.add('d-none');
    }
  };

  /**
   * @private
   */
  _setPreview() {
    const ignoredInputs = [
      'background-height',
      'background-height-unit',
      'background-position',
      'background-repeat',
      'background-size',
      'background-width',
      'background-width-unit',
    ];
    const hasBorders = this._elem.querySelector(this._dom.borders.toggle).checked;
    const styles = {};

    // Get inputs values
    Object.keys(this._inputs).filter((property) => {
      return (ignoredInputs.indexOf(property) === -1);
    })
      .forEach((property) => {
        const input = this._elem.querySelector(`[data-property="${property}"]`);
        const isRadio = input.getAttribute('type') === 'radio';
        let value = isRadio ? '' : this._inputs[property];
        const isSideBorder = property.match(/^border-(top|right|bottom|left)-(style|color|width)$/) !== null;
        const isBorder = (isSideBorder === true) || (property.match(/^border-(style|color|width)$/) !== null);
        const isPadding = property.match(/^padding-(top|right|bottom|left)$/) !== null;
        const isRadius = property.match(/^border-(top-left|top-right|bottom-right|bottom-left)-radius$/) !== null;

        if (isRadio) {
          this._elem.querySelectorAll(`[data-property="${property}"]`).forEach((radio) => {
            if (radio.checked) {
              value = radio.getAttribute('value');
            }
          });
        }

        if ((property === 'background-image') && (typeof value !== 'object')) {
          styles['background-image'] = `url(${value})`;

          let size = this._inputs['background-size'];
          if (['%', 'px'].indexOf(size) !== -1) {
            const w = this._elem.querySelector('[data-property="background-width"]').value;
            const h = this._elem.querySelector('[data-property="background-height"]').value;

            this._elem.querySelector('[data-property="background-width-unit"]').innerText = size;
            this._elem.querySelector('[data-property="background-height-unit"]').innerText = size;
            size = `${w === '' ? 'auto' : w + size} ${h === '' ? 'auto' : h + size}`;
          }
          if ((size !== '') && (size !== 'auto auto')) {
            styles['background-size'] = size;
          }
          styles['background-position'] = this._inputs['background-position'];
          styles['background-repeat'] = this._inputs['background-repeat'];
        } else if ((isBorder === true) && (hasBorders === true) && (typeof value !== 'object') && (value !== '')) {
          styles[property] = property.endsWith('width') ? `${value}px` : value;
        } else if ((isPadding === true) || (isRadius === true)) {
          styles[property] = (typeof value === 'object') || (value === '0') || (value === '') ? '0' : `${value}px`;
        } else if ((typeof value !== 'object') && (value !== '')) {
          styles[property] = value;
        }
      });

    // borders CSS shortcuts
    ['border', 'border-top', 'border-right', 'border-bottom', 'border-left'].forEach((side) => {
      if ((typeof styles[`${side}-style`] !== 'undefined') &&
        (typeof styles[`${side}-width`] !== 'undefined') &&
        (typeof styles[`${side}-color`] !== 'undefined')) {
        const width = styles[`${side}-width`] === '0px' ? '' : styles[`${side}-width`];
        const style = styles[`${side}-style`];
        const color = styles[`${side}-color`];

        if ((width !== '') && (color !== '')) {
          styles[side] = `${width} ${style} ${color}`;
        }
      }

      delete styles[`${side}-width`];
      delete styles[`${side}-style`];
      delete styles[`${side}-color`];
    });

    // padding CSS shortcut
    const padding = [];
    ['top', 'right', 'bottom', 'left'].forEach((side) => {
      if (typeof styles[`padding-${side}`] !== 'undefined') {
        padding.push(styles[`padding-${side}`]);
        delete styles[`padding-${side}`];
      }
    });
    if (padding.length !== 0) {
      const equals = padding.every((val, i, arr) => val === arr[0]);

      if (equals === false) {
        styles['padding'] = padding.join(' ');
      } else if (padding[0] !== '0') {
        styles['padding'] = padding[0];
      }
    }

    // radius CSS shortcut
    const borderRadius = [];
    ['top-left', 'top-right', 'bottom-right', 'bottom-left'].forEach((side) => {
      if (typeof styles[`border-${side}-radius`] !== 'undefined') {
        borderRadius.push(styles[`border-${side}-radius`]);
        delete styles[`border-${side}-radius`];
      }
    });
    if (borderRadius.length !== 0) {
      const equals = borderRadius.every((val, i, arr) => val === arr[0]);

      if (equals === false) {
        styles['border-radius'] = borderRadius.join(' ');
      } else if (borderRadius[0] !== '0') {
        styles['border-radius'] = borderRadius[0];
      }
    }

    // Set selection
    const selection = [];
    Object.keys(styles).forEach((property) => {
      if (styles[property] !== null && styles[property] !== '') {
        selection.push(`${property}:${styles[property]}`);
      }
    });

    this._selection.value = selection.join(';');

    // Set preview
    if (this._preview !== null) {
      this._preview.querySelector('.preview-content').setAttribute('style', this._selection.value);

      if (typeof styles['border-radius'] !== 'undefined') {
        this._preview.setAttribute('style', `border-radius:${styles['border-radius']}`);
      } else {
        this._preview.removeAttribute('style');
      }
    }

    this._dispatchChangeEvent();
  };

  /**
   * @private
   */
  _setPadding() {
    const locked = this._elem.querySelector(this._dom.padding.toggle).checked === false;
    const paddingRight = this._elem.querySelector('[data-property="padding-right"]');
    const paddingBottom = this._elem.querySelector('[data-property="padding-bottom"]');
    const paddingLeft = this._elem.querySelector('[data-property="padding-left"]');

    if (locked) {
      const padding = this._elem.querySelector('[data-property="padding-top"]').value;
      ['right', 'bottom', 'left'].forEach((side) => {
        this._elem.querySelector(`[data-property="padding-${side}"]`).value = padding;
        this._inputs[`padding-${side}`] = padding === '' ? null : padding;
      });

      paddingRight.closest('.row').classList.add('d-none');
      paddingBottom.closest('.row').classList.add('d-none');
      paddingLeft.closest('.row').classList.add('d-none');

      // switch logo
      this._elem.querySelector('.margin-top-icon').classList.add('d-none');
      this._elem.querySelector('.margin-uniform-icon').classList.remove('d-none');
    } else {
      paddingRight.closest('.row').classList.remove('d-none');
      paddingBottom.closest('.row').classList.remove('d-none');
      paddingLeft.closest('.row').classList.remove('d-none');

      // switch logo
      this._elem.querySelector('.margin-top-icon').classList.remove('d-none');
      this._elem.querySelector('.margin-uniform-icon').classList.add('d-none');
    }
  };

  /**
   * @private
   */
  _setRadius() {
    const locked = this._elem.querySelector(this._dom.radius.toggle).checked === false;
    const topRightRadius = this._elem.querySelector('[data-property="border-top-right-radius"]');
    const bottomRightRadius = this._elem.querySelector('[data-property="border-bottom-right-radius"]');
    const bottomLeftRadius = this._elem.querySelector('[data-property="border-bottom-left-radius"]');

    if (locked) {
      const radius = this._elem.querySelector('[data-property="border-top-left-radius"]').value;
      ['top-right', 'bottom-right', 'bottom-left'].forEach((side) => {
        this._elem.querySelector(`[data-property="border-${side}-radius"]`).value = radius;
        this._inputs[`border-${side}-radius`] = radius === '' ? null : radius;
      });

      topRightRadius.closest('.col-lg-6').classList.add('d-none');
      bottomRightRadius.closest('.col-lg-6').classList.add('d-none');
      bottomLeftRadius.closest('.col-lg-6').classList.add('d-none');

      // switch logo
      this._elem.querySelector('.border-radius-top-icon').classList.add('d-none');
      this._elem.querySelector('.border-radius-uniform-icon').classList.remove('d-none');
    } else {
      topRightRadius.closest('.col-lg-6').classList.remove('d-none');
      bottomRightRadius.closest('.col-lg-6').classList.remove('d-none');
      bottomLeftRadius.closest('.col-lg-6').classList.remove('d-none');

      // switch logo
      this._elem.querySelector('.border-radius-top-icon').classList.remove('d-none');
      this._elem.querySelector('.border-radius-uniform-icon').classList.add('d-none');
    }
  };

  /**
   * @private
   */
  _setValues() {
    const borders = [];
    Object.keys(this._inputs).filter((property) => {
      return typeof this._inputs[property] !== 'object';
    }).forEach((property) => {
      const target = this._elem.querySelector(`[data-property="${property}"]`);
      const value = this._inputs[property];
      const isInput = /^(?:input|select)$/i.test(target.nodeName);
      const isRadio = target.hasAttribute('type') && (target.getAttribute('type') === 'radio');

      if ((property.match(/^border-(style|width|color)$/) !== null) ||
        (property.match(/^border-(top|right|bottom|left)-(style|width|color)$/) !== null)) {
        if (value !== null && value !== '') {
          borders.push(property);
        }
      }

      if (isRadio) {
        this._elem.querySelector(`[data-property="${property}"][value="${value}"]`).checked = true;
      } else if (isInput) {
        target.value = value;
      } else {
        target.innerText = value;
      }

      if (property.indexOf('color') !== -1) {
        $(target).spectrum('set', value);
      }
    });

    const hasBorders = borders.length > 0;

    if (hasBorders) {
      const sides = ['top', 'right', 'bottom', 'left'];
      let locked = true;
      sides.forEach((side) => {
        locked = (locked === true) && (typeof this._inputs[`border-${side}-width`] !== 'object') ? false : locked;
      });

      if (locked === false) {
        sides.forEach((side) => {
          if (this._inputs[`border-${side}-width`] !== false) {
            this._elem.querySelectorAll(`[data-property="border-${side}-style"]`).forEach((radio) => {
              radio.checked = radio.getAttribute('value') === this._inputs[`border-${side}-style`];
            });

            $(this._elem.querySelector(`[data-property="border-${side}-color"]`))
              .spectrum('set', this._inputs[`border-${side}-color`]);

            this
              ._elem
              .querySelector(`[data-property="border-${side}-width"]`)
              .value = this._inputs[`border-${side}-width`];
          }
        });
      } else {
        this._elem.querySelectorAll(`[data-property="border-style"]`).forEach((radio) => {
          radio.checked = radio.getAttribute('value') === this._inputs[`border-style`];
        });
        $(this._elem.querySelector(`[data-property="border-color"]`)).spectrum('set', this._inputs[`border-color`]);
        this._elem.querySelector(`[data-property="border-width"]`).value = this._inputs[`border-width`];
      }

      this._bordersLocked(locked);
    }

    // Handle padding lock

    const paddingTop = this._elem.querySelector('[data-property="padding-top"]');
    const paddingRight = this._elem.querySelector('[data-property="padding-right"]');
    const paddingBottom = this._elem.querySelector('[data-property="padding-bottom"]');
    const paddingLeft = this._elem.querySelector('[data-property="padding-left"]');

    const paddingLocked = [paddingTop.value, paddingRight.value, paddingBottom.value, paddingLeft.value]
      .every((val, i, arr) => val === arr[0]);

    if (paddingLocked === false) {
      this
        ._elem
        .querySelector(this._dom.padding.toggle)
        .setAttribute('checked', 'checked');

      paddingRight.closest('.row').classList.remove('d-none');
      paddingBottom.closest('.row').classList.remove('d-none');
      paddingLeft.closest('.row').classList.remove('d-none');

      // switch logo
      this._elem.querySelector('.margin-top-icon').classList.remove('d-none');
      this._elem.querySelector('.margin-uniform-icon').classList.add('d-none');
    } else {
      paddingRight.closest('.row').classList.add('d-none');
      paddingBottom.closest('.row').classList.add('d-none');
      paddingLeft.closest('.row').classList.add('d-none');

      // switch logo
      this._elem.querySelector('.margin-top-icon').classList.add('d-none');
      this._elem.querySelector('.margin-uniform-icon').classList.remove('d-none');
    }

    // Handle radius lock

    const topLeftRadius = this._elem.querySelector('[data-property="border-top-left-radius"]');
    const topRightRadius = this._elem.querySelector('[data-property="border-top-right-radius"]');
    const bottomRightRadius = this._elem.querySelector('[data-property="border-bottom-right-radius"]');
    const bottomLeftRadius = this._elem.querySelector('[data-property="border-bottom-left-radius"]');

    const radiusLocked = [topLeftRadius.value, topRightRadius.value, bottomRightRadius.value, bottomLeftRadius.value]
      .every((val, i, arr) => val === arr[0]);

    if (radiusLocked === false) {
      this
        ._elem
        .querySelector(this._dom.radius.toggle)
        .setAttribute('checked', 'checked');

      topRightRadius.closest('.col-lg-6').classList.remove('d-none');
      bottomRightRadius.closest('.col-lg-6').classList.remove('d-none');
      bottomLeftRadius.closest('.col-lg-6').classList.remove('d-none');

      // switch logo
      this._elem.querySelector('.border-radius-top-icon').classList.remove('d-none');
      this._elem.querySelector('.border-radius-uniform-icon').classList.add('d-none');
    } else {
      topRightRadius.closest('.col-lg-6').classList.add('d-none');
      bottomRightRadius.closest('.col-lg-6').classList.add('d-none');
      bottomLeftRadius.closest('.col-lg-6').classList.add('d-none');

      // switch logo
      this._elem.querySelector('.border-radius-top-icon').classList.add('d-none');
      this._elem.querySelector('.border-radius-uniform-icon').classList.remove('d-none');
    }
  };

  /**
   * @private
   */
  _toggleSelected() {
    this._elem.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.parentNode.classList.toggle('selected', input.checked);
    });
  };

  /**
   * @private
   */
  _dispatchChangeEvent() {
    this._elem.dispatchEvent(
      new CustomEvent(
        'design-tool.change', {
          'detail': this.getValue(),
        },
      ),
    );
  }
};

export {DesignTool};
